import { MenuFixedItems, ToolbarNavRoot } from 'features/toolbar/toolbar/styles';
import CameraControl from 'features/toolbar/toolbar/controls/CameraControl';
import MicControl from 'features/toolbar/toolbar/controls/MicControl';
import { ToolbarOrientation } from 'features/toolbar/types';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import GlobalAudioMuteControl from 'features/toolbar/toolbar/controls/global-audio-mute/GlobalAudioMuteControl';
import { useAppSelector } from 'store/hooks';
import { selectToolbarHasUpdates } from 'features/toolbar/selectors/selectToolbarHasUpdates';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import EndCallControl from 'features/toolbar/toolbar/controls/end-call/EndCallControl';
import ScreenshareControl from 'features/toolbar/toolbar/controls/ScreenshareControl';
import { selectMobileScreenshare } from 'features/sdk/sdkStateSlice';

export type MobileNavProps = {
  orientation: ToolbarOrientation;
  onHamburgerClick: () => void;
};

const MobileNav = ({ orientation, onHamburgerClick }: MobileNavProps) => {
  const { t } = useTranslation('room');

  const { hasPermissions } = usePermissions();

  const allowVideoBroadcast = hasPermissions(PermissionTypes.broadcastVideo);
  const allowAudioBroadcast = hasPermissions(PermissionTypes.broadcastAudio);

  const globalAudioMuteAvailable = useFeatureFlag('muteSound');

  const toolbarHasUpdates = useAppSelector(selectToolbarHasUpdates);

  const screenshareFeatureAvailable = useFeatureFlag('screenshare');
  const allowScreenshare = hasPermissions(PermissionTypes.screenshare);
  const mobileScreenshare = useAppSelector(selectMobileScreenshare);

  const screenshareAvailable = screenshareFeatureAvailable && allowScreenshare && mobileScreenshare;

  return (
    <ToolbarNavRoot orientation={orientation}>
      <MenuFixedItems orientation={orientation}>
        {allowVideoBroadcast && <CameraControl />}
        {allowAudioBroadcast && <MicControl />}
        {globalAudioMuteAvailable && <GlobalAudioMuteControl />}
        {screenshareAvailable && <ScreenshareControl />}
      </MenuFixedItems>
      <ToolbarMenuItem
        id="mobile-menu"
        ariaLabel={t('toolbar.mobile_menu_trigger')}
        icon="settings1"
        onClick={onHamburgerClick}
        badgeActive
        BadgeProps={{
          invisible: !toolbarHasUpdates,
          variant: 'dot',
        }}
      >
        {t('tabs.public_chat.tab_label')}
      </ToolbarMenuItem>
      <EndCallControl />
    </ToolbarNavRoot>
  );
};

export default MobileNav;
